import type {StartMaterijalData} from './Step3'
import {FmkNalogiStavkeModel} from '../../../../models/FmkNaloziModel'
import {getStavkaId} from './materijalHelpers'

export const validateMaterijal = (materijal: StartMaterijalData | undefined, stavke: FmkNalogiStavkeModel['stavka']) => {
    if (!materijal?.tip) return 'Odaberite materijal: ROLNA ili TRAKA.'
    if (!stavke.length) return 'Odaberite najmanje jednu stavku naloga.'
    const rows = materijal.materijali
    if (!rows.length || rows.some((row) => !row.MaterijalId)) {
        return 'Upišite broj za svaki materijal ili uklonite prazan red.'
    }
    if (rows.some((row) => !row.StavkaIds.length)) {
        return 'Za svaki materijal označite stavke koje ćete od njega raditi.'
    }
    if (new Set(rows.map((row) => row.MaterijalId)).size !== rows.length) {
        return 'Isti materijal je upisan više puta. Označite sve njegove stavke u jednom redu.'
    }
    if (rows.some((row) => row.Ucitavanje)) return 'Sačekajte da se završi provjera materijala.'
    if (rows.some((row) => row.NormativPoruka && !row.Provjeren)) return 'Ispravite označene greške na materijalu prije pokretanja naloga.'
    if (rows.some((row) => !row.Provjeren || row.StavkaIds.some((id) =>
        !stavke.some((stavka) => String(getStavkaId(stavka)) === id) ||
        !Number.isFinite(row.PotrebneKolicinePoStavci[id])
    ))) return 'Provjerite broj materijala i sačekajte obračun normativa.'
    return ''
}

export const buildMaterijalPayload = (materijal: StartMaterijalData, stavke: FmkNalogiStavkeModel['stavka']) => {
    const rows = materijal.materijali.filter((row) => row.MaterijalId)
    const assignedStavke = stavke.filter((stavka) => rows.some((row) =>
        row.StavkaIds.includes(String(getStavkaId(stavka)))
    ))
    const expanded = rows.flatMap((row) => assignedStavke
        .filter((stavka) => row.StavkaIds.includes(String(getStavkaId(stavka))))
        .map((stavka) => ({
            IdStavkeFMK: getStavkaId(stavka),
            ...(materijal.tip === 'rolna' ? {RolnaId: row.MaterijalId} : {TrakaId: row.MaterijalId}),
            PotrebnaKolicina: row.PotrebneKolicinePoStavci[String(getStavkaId(stavka))],
            Skenirano: row.Skenirano,
        })))
    return {
        ...materijal,
        stavke: assignedStavke,
        // UI state is kept out of the request; the existing per-item API rows carry the assignments.
        materijali: rows.map(({RowId, Provjeren, Ucitavanje, ...row}) => row),
        rolne: materijal.tip === 'rolna' ? expanded : [],
        trake: materijal.tip === 'traka' ? expanded : [],
    }
}
